import React, { useState } from "react";
import { useSelector } from "react-redux";
import { selectUser } from "../Features/userSlice";
import "../Style/QuestionBox.css";
import Modal from "react-modal";
import LinkIcon from "@material-ui/icons/Link";
import db from "../firebase";
import firebase from "firebase";
import { Avatar, Button, TextField } from "@material-ui/core";
import InputAdornment from "@material-ui/core/InputAdornment";
import InputLabel from "@material-ui/core/InputLabel";
import NativeSelect from "@material-ui/core/NativeSelect";

function QuestionBox() {
  const user = useSelector(selectUser);
  const [openModal, setOpenModal] = useState(false);
  const [input, setInput] = useState("");
  const [inputUrl, setInputUrl] = useState("");
  const [option, setOption] = useState("");

  const handleQuestion = (e) => {
    e.preventDefault();
    if (user) {
      db.collection("questions").add({
        question: input,
        imageUrl: inputUrl,
        timestamp: firebase.firestore.FieldValue.serverTimestamp(),
        user: user,
        option: option,
      });
    }

    setInput("");
    setInputUrl("");

    setOpenModal(false);
  };

  return (
    <div className="questionBox">
      <div className="questionBox__info" onClick={() => setOpenModal(true)}>
        <Avatar src={user ? user.photo : Avatar} />
        <h5>{user ? user.displayName : "Login to Ask"}</h5>
      </div>
      <div className="questionBox__question" onClick={() => setOpenModal(true)}>
        <p>Ask how to start a project here</p>
      </div>
      <div className="questionBox__Modal">
        <Modal
          isOpen={openModal}
          onRequestClose={() => setOpenModal(false)}
          shouldCloseOnOverlayClick={true}
          style={{
            overlay: {
              width: 700,
              height: 650,
              backgroundColor: "transparent",
              boxShadow:
                "box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
              zIndex: "1100",
              top: "55%",
              left: "50%",
              marginTop: "-350px",
              marginLeft: "-380px",
            },
          }}
        >
          <div className="modal__title">
            <h5>Add Question Here</h5>
          </div>
          <div className="modal__info">
            <Avatar
              Avatar
              className="avatar"
              src={user ? user.photo : Avatar}
            />
            <p>{user ? user.displayName : "Guest User"} wants to know</p>
            <div className="modal__scope">
              <InputLabel htmlFor="select">Category</InputLabel>
              <NativeSelect
                id="select"
                value={option}
                onChange={(e) => setOption(e.target.value)}
              >
                <option>Choose Project Type</option>
                <option>Software Project</option>
                <option> Engineering Project</option>
              </NativeSelect>
            </div>
          </div>
          <div className="modal__field">
            <TextField
              required
              fullWidth
              margin="dense"
              multiline
              rows="8"
              variant="outlined"
              id="ask question"
              value={input}
              onChange={(e) => setInput(e.target.value)}
              type="text"
              placeholder="Ask where to start on your project with a specific 'How' or 'What' question."
            />
            <div className="modal__fieldLink">
              <TextField
                InputProps={{
                  endAdornment: (
                    <InputAdornment>
                      <LinkIcon className="modal__fieldLinkIcon" />
                    </InputAdornment>
                  ),
                }}
                fullWidth
                margin="dense"
                multiline
                rows="1"
                variant="outlined"
                id="input URL"
                value={inputUrl}
                onChange={(e) => setInputUrl(e.target.value)}
                type="text"
                placeholder="Add a link to help others understand what you want to build."
              />
            </div>
            <div className="modal__buttons">
              <Button onClick={() => setOpenModal(false)} className="cancel">
                Close
              </Button>
              <Button onClick={handleQuestion} type="submit" className="add">
                Add Question
              </Button>
            </div>
          </div>
        </Modal>
      </div>
    </div>
  );
}

export default QuestionBox;
